// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='status-option'] .statusItem {\r\n    width: 100%;\r\n  }\r\n  [name='status-option'] .plain {\r\n    text-align: left;\r\n  }\r\n  [name='status-option'] .mtimeWithStatus {\r\n    font-size: 12px;\r\n    color: var(--secondary-font-color);\r\n  }", ""]);
// Exports
module.exports = exports;
